// extracted by mini-css-extract-plugin
export default {"questionsContainer":"Question_questionsContainer__e8TRp","container":"Question_container__mFAn-"};